import * as React from 'react';

import BaseDialog, { BaseDialogProps } from '../Base';
import { ManageContentTipsV2 } from './ManageContentTipsV2';

export const ManageContentTipsDialogV2: React.FC<BaseDialogProps> = (props) => {
  return (
    <BaseDialog {...props} width='533px' height='unset'>
      <ManageContentTipsV2 />
    </BaseDialog>
  );
};
